var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDrop = function SvgIconDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12 1.5.573-.82a1 1 0 0 0-1.146 0zm-.524 1.688q.296-.25.524-.432.228.18.524.432a23.4 23.4 0 0 1 2.471 2.437c1.818 2.09 3.505 4.86 3.505 7.875a6.5 6.5 0 1 1-13 0c0-3.015 1.687-5.785 3.505-7.875a23.4 23.4 0 0 1 2.47-2.437M12 1.5c-.573-.82-.574-.819-.574-.819l-.003.002-.006.004-.02.015-.07.05-.257.192a25.393 25.393 0 0 0-3.575 3.368C5.563 6.536 3.5 9.766 3.5 13.5a8.5 8.5 0 0 0 17 0c0-3.735-2.063-6.965-3.995-9.187A25.4 25.4 0 0 0 12.93.944a15 15 0 0 0-.327-.242l-.02-.015-.006-.004-.002-.001h-.001zm4.266 12.969a1 1 0 0 0-1.951-.438 2.36 2.36 0 0 1-1.784 1.784 1 1 0 1 0 .438 1.951 4.36 4.36 0 0 0 3.297-3.297",
    clipRule: "evenodd"
  })));
};
export default SvgIconDrop;